import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { useSettings } from "@/lib/SettingsContext";

const EASE = [0.16, 1, 0.3, 1];

const Stars = () => (
  <div className="flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-[#D4AF37] text-[#D4AF37]" />
    ))}
  </div>
);

export default function Testimonials() {
  const settings = useSettings();
  const reviews = settings.reviews || [];

  return (
    <section id="reviews" data-testid="testimonials-section" className="bg-[#F3EFEA] py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-16 flex flex-wrap items-end justify-between gap-6"
        >
          <div>
            <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-[#1B523F]">
              Word of Mouth
            </p>
            <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-[#121A16] sm:text-5xl">
              Essex, <em className="italic text-[#0F382A]">in their words.</em>
            </h2>
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#4A5A52]">
            5.0 average · 120+ local reviews
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {reviews.map((r, i) => (
            <motion.figure
              key={r.name + i}
              data-testid={`review-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: EASE }}
              className="flex flex-col justify-between rounded-[1.75rem] border border-[#E5DEC3] bg-[#FAF8F5] p-8 transition-[box-shadow,transform] duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(11,29,22,0.2)] lg:p-10"
            >
              <div>
                <Stars />
                <blockquote className="mt-6 font-serif text-xl font-light leading-relaxed text-[#121A16]">
                  “{r.quote}”
                </blockquote>
              </div>
              <figcaption className="mt-8 border-t border-[#E5DEC3] pt-5">
                <p className="text-sm font-semibold text-[#0F382A]">{r.name}</p>
                <p className="mt-0.5 font-mono text-[11px] uppercase tracking-[0.2em] text-[#4A5A52]">
                  {r.place}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
